export const Swirls = ({ startColor, endColor, ...props }: SwirlsProps) => (
  <svg viewBox="0 0 778 778" aria-hidden="true" {...(props as JSX.IntrinsicElements["svg"])}>
    <use href="#--c" fill="none">
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="0 389 389"
        to="360 389 389"
        dur="10s"
        repeatCount="indefinite"
      />
    </use>
    <g transform="translate(72,72) scale(.8)">
      <use href="#--c" fill="none">
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 389 389"
          to="360 389 389"
          dur="9s"
          begin="-1s"
          repeatCount="indefinite"
        />
      </use>
    </g>
    <g transform="translate(144,144) scale(.6)">
      <use href="#--c" fill="none">
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 389 389"
          to="360 389 389"
          dur="8s"
          begin="-2s"
          repeatCount="indefinite"
        />
      </use>
    </g>
    <defs>
      <linearGradient id="--g" x1="50%" y1="0" x2="50%" y2="100%" gradientUnits="userSpaceOnUse">
        <stop stopColor={startColor} />
        <stop stopColor={endColor} offset=".3" />
        <stop stopColor={endColor} offset=".73" />
        <stop stopColor={startColor} offset="1" />
      </linearGradient>
      <symbol id="--c">
        <circle
          cx="389"
          cy="389"
          r="388"
          stroke="url(#--g)"
          strokeOpacity=".43"
          strokeWidth="2"
          opacity=".5"
        />
      </symbol>
    </defs>
  </svg>
)

export type SwirlsProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLElement>,
  HTMLElement
> & {
  startColor: string
  endColor: string
}
